module.exports = __webpack_public_path__ + "static/media/s_v10_1.66a515b3.mp3";